var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "39",
        height: "39",
        viewBox: "0 0 39 39",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: {
          cx: "19.5",
          cy: "19.5",
          r: "19",
          fill: "white",
          "fill-opacity": "0.2",
          stroke: "url(#paint0_linear)",
        },
      }),
      _c("path", {
        attrs: {
          d: "M26.4423 15.1875H25.614C25.5111 13.6465 24.8306 12.2023 23.71 11.1466C22.5894 10.0909 21.1122 9.50239 19.5769 9.5H18.3654C16.8301 9.50239 15.3529 10.0909 14.2323 11.1466C13.1117 12.2023 12.4312 13.6465 12.3283 15.1875H11.9038C11.7967 15.1875 11.694 15.2303 11.6183 15.3065C11.5425 15.3827 11.5 15.486 11.5 15.5938V27.7812C11.5006 28.3198 11.7136 28.8361 12.0921 29.2168C12.4707 29.5976 12.9839 29.8119 13.5192 29.8125H24.8269C25.3623 29.8119 25.8755 29.5976 26.254 29.2168C26.6326 28.8361 26.8455 28.3198 26.8462 27.7812V15.5938C26.8462 15.486 26.8036 15.3827 26.7279 15.3065C26.6521 15.2303 26.5494 15.1875 26.4423 15.1875ZM18.3654 10.3125H19.5769C20.8983 10.3146 22.1703 10.8176 23.1395 11.7211C24.1087 12.6246 24.7038 13.8623 24.8063 15.1875H13.136C13.2385 13.8623 13.8336 12.6246 14.8028 11.7211C15.772 10.8176 17.044 10.3146 18.3654 10.3125ZM17.5577 17.625C17.1293 17.625 16.7184 17.7962 16.4154 18.101C16.1125 18.4057 15.9423 18.819 15.9423 19.25V21.6875C15.9423 21.903 15.8572 22.1097 15.7057 22.262C15.5543 22.4144 15.3488 22.5 15.1346 22.5C14.9204 22.5 14.715 22.4144 14.5635 22.262C14.412 22.1097 14.3269 21.903 14.3269 21.6875V16H20.7885V20.0625C20.7885 20.278 20.7034 20.4847 20.5519 20.637C20.4004 20.7894 20.195 20.875 19.9808 20.875C19.7666 20.875 19.5611 20.7894 19.4096 20.637C19.2582 20.4847 19.1731 20.278 19.1731 20.0625V19.25C19.1731 18.819 19.0029 18.4057 18.6999 18.101C18.397 17.7962 17.9861 17.625 17.5577 17.625ZM12.3077 16H13.5192V17.625H12.3077V16ZM26.0385 27.7812C26.0385 28.1045 25.9108 28.4145 25.6836 28.643C25.4564 28.8716 25.1482 29 24.8269 29H13.5192C13.1979 29 12.8898 28.8716 12.6625 28.643C12.4353 28.4145 12.3077 28.1045 12.3077 27.7812V18.4375H13.5192V21.6875C13.5192 22.1185 13.6894 22.5318 13.9924 22.8365C14.2953 23.1413 14.7062 23.3125 15.1346 23.3125C15.563 23.3125 15.9739 23.1413 16.2769 22.8365C16.5798 22.5318 16.75 22.1185 16.75 21.6875V19.25C16.75 19.0345 16.8351 18.8278 16.9866 18.6755C17.138 18.5231 17.3435 18.4375 17.5577 18.4375C17.7719 18.4375 17.9773 18.5231 18.1288 18.6755C18.2803 18.8278 18.3654 19.0345 18.3654 19.25V20.0625C18.3654 20.4935 18.5356 20.9068 18.8385 21.2115C19.1415 21.5163 19.5523 21.6875 19.9808 21.6875C20.4092 21.6875 20.8201 21.5163 21.123 21.2115C21.426 20.9068 21.5962 20.4935 21.5962 20.0625V18.4375H26.0385V27.7812ZM26.0385 17.625H21.5962V16H26.0385V17.625Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M15.1349 24.125C14.8154 24.125 14.5031 24.2203 14.2375 24.3989C13.9718 24.5774 13.7648 24.8312 13.6425 25.1281C13.5202 25.4251 13.4882 25.7518 13.5506 26.067C13.6129 26.3822 13.7668 26.6718 13.9927 26.899C14.2186 27.1263 14.5064 27.2811 14.8198 27.3438C15.1331 27.4065 15.4579 27.3743 15.7531 27.2513C16.0483 27.1283 16.3006 26.92 16.4781 26.6528C16.6556 26.3856 16.7503 26.0714 16.7503 25.75C16.7503 25.319 16.5801 24.9057 16.2772 24.601C15.9742 24.2962 15.5633 24.125 15.1349 24.125ZM15.1349 26.5625C14.9752 26.5625 14.819 26.5148 14.6862 26.4256C14.5534 26.3363 14.4498 26.2094 14.3887 26.0609C14.3276 25.9125 14.3116 25.7491 14.3427 25.5915C14.3739 25.4339 14.4508 25.2891 14.5638 25.1755C14.6767 25.0618 14.8207 24.9845 14.9773 24.9531C15.134 24.9218 15.2964 24.9379 15.444 24.9993C15.5916 25.0608 15.7177 25.165 15.8065 25.2986C15.8952 25.4322 15.9426 25.5893 15.9426 25.75C15.9426 25.9655 15.8575 26.1722 15.706 26.3245C15.5546 26.4769 15.3491 26.5625 15.1349 26.5625Z",
          fill: "white",
        },
      }),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear",
                x1: "19.5",
                y1: "0",
                x2: "19.5",
                y2: "39",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { "stop-color": "white", "stop-opacity": "0" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "white" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }